import {App} from "vue";
import {app} from "@/di";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

export default {
  install(vueApp: App<Element>) {
    vueApp.config.globalProperties.$config = (key: any): any => {
      return app.get(ConfigRepository).get(key);
    };
  },
};